import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      fill='000000'
      d='M4,15v2.6C4,20,6,22,8.4,22l0,0c2.5,0,4.5-2,4.5-4.5V6.4c0-1.5,1.2-2.7,2.7-2.7l0,0c1.5,0,2.7,1.2,2.7,2.7c0,0,0,2.8,0,4.3
	s1.8,1.6,1.8,0V6.4C20,4,18,2,15.6,2l0,0c-2.5,0-4.5,2-4.5,4.5v11.1c0,1.5-1.2,2.7-2.7,2.7l0,0c-1.5,0-2.7-1.2-2.7-2.7
	c0-1.8,0,4.3,0-2.6C5.7,13.4,4,13.4,4,15z'
    />,
    <path key='1' fill='000000' d='M19.2,22.2l3.7-9.1l-0.4-0.4l-3.4,1.5l-3.4-1.5l-0.4,0.4L19.2,22.2z' />,
    <path
      key='2'
      fill='000000'
      d='M4.8,1.5L4.8,1.5c-2,0-3.6,1.6-3.6,3.6c0,0.9,0.3,1.7,0.7,2.5c0.5,0.8,1.1,1.5,1.6,2.3c0.2,0.4,0.4,0.8,0.6,1.2
	c0.1,0.3,0.2,0.8,0.7,0.8l0,0c0.4,0,0.5-0.5,0.6-0.8c0.2-0.4,0.4-0.8,0.6-1.2c0.5-0.8,1.1-1.5,1.6-2.3c0.5-0.8,0.7-1.6,0.7-2.5
	C8.4,3.1,6.8,1.5,4.8,1.5z M4.8,6.6C4.1,6.6,3.5,6,3.5,5.3S4.1,4,4.8,4s1.3,0.6,1.3,1.3S5.5,6.6,4.8,6.6z'
    />,
  ],
  'TransportTrailer'
);

const TransportTrackIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportTrackIcon);
